import { MapZoomType } from "@/utils/types";
import { LngLatBoundsLike, ProjectionSpecification } from "mapbox-gl";
import { ControlsProps } from "@/utils/types";

export interface MapParamsProps extends ControlsProps {
	colors: string[];
	extents: number[] | string[];
};

// Map > Mapbox
export const MAPBOX_USERNAME = "echo-lab";
export const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiZWNoby1sYWIiLCJhIjoiY21tajl4cnJ3MWM0bTJwcHJwbTBnbHV2biJ9.xJY5sLpiEN3fD2hPSb9AQQ";
// export const MAPBOX_STYLE_URI = "mapbox://styles/hyperobjekt/cm7w2o3v9001x01sde7cy3m06";
// Map > Sources
export const MAP_VERSION = "8";


// Map > Tileset Keys
export const MAP_GEO_KEYS = ["state", "county", "tract"];
export const MAP_VIEW_KEYS = ["smoke", "heat", "cold"];
// export const MAP_YEAR_GROUPS_BY_VIEW = {
// 	smoke: ["avg", "00", "10", "15", "20"],
// 	heat: ["avg"],
// 	cold: ["avg"],
// };
export const MAP_COUNTY_FILL_LAYER_ID = "county-fill";
export const MAP_TRACT_FILL_LAYER_ID = "tract-fill";
export const MAP_INTERACTIVE_LAYER_IDS = [
	MAP_COUNTY_FILL_LAYER_ID,
	MAP_TRACT_FILL_LAYER_ID,
];
// Map > Projection
export const MAP_PROJECTION_NAME = "mercator";
export const MAP_PROJECTION: ProjectionSpecification = {
	name: MAP_PROJECTION_NAME
};
// Map > View State
export const MAP_BOUNDS_USA: LngLatBoundsLike = [
	[-124.8, 24.21], // SW
	[-66.8, 49.61] // NE
];
export const MAP_BOUNDS_CA: LngLatBoundsLike = [
	[-124.41060660766607, 32.5342307609976], // SW
	[-114.13445790587905, 42.00965914828148] // NE
];
export const MAP_BOUNDS_AK: LngLatBoundsLike = [
	[-166.2150, 51.2839], // SW
	[-129.9999, 71.3525] // NE
];
export const MAP_BOUNDS_HI: LngLatBoundsLike = [
	[-160.475434, 18.169453], // SW
	[-154.015474, 22.971147] // NE
];
export const MAP_DEFAULT_BOUNDS = MAP_BOUNDS_USA;
export const MAP_DEFAULT_PADDING = {
	left: 350,
	right: 50,
	top: 150,
	bottom: 50,
};
export const MAP_DEFAULT_PADDING_MOBILE = {
	left: 10,
	right: 10,
	top: 10,
	bottom: 10,
};
export const MAP_INITIAL_VIEW_STATE = {
	bounds: MAP_DEFAULT_BOUNDS,
	fitBoundsOptions: {
		padding: MAP_DEFAULT_PADDING
	}
};
// Map > Zoom
export const MAP_MIN_ZOOM = 3;
export const MAP_MAX_ZOOM = 12;
// Map > Lines
export const MAP_LINE_WIDTH = 0.25;
export const MAP_LINE_HOVER_WIDTH = 2;
// Map > CSS Style
const MAP_CSS_STYLE = {
	width: "100%",
	height: "100%"
};
// Map > Defaults
export const MAP_DEFAULT_PROPS = {
	mapboxAccessToken: MAPBOX_ACCESS_TOKEN,
	// mapStyle: MAPBOX_STYLE_URI,
	projection: MAP_PROJECTION,
	initialViewState: MAP_INITIAL_VIEW_STATE,
	minZoom: MAP_MIN_ZOOM,
	maxZoom: MAP_MAX_ZOOM,
	// maxBounds: MAP_MAX_BOUNDS,
	style: MAP_CSS_STYLE,
	interactiveLayerIds: MAP_INTERACTIVE_LAYER_IDS,
	dragRotate: false
};
// Map > Fly
export const MAP_FLY_DURATION = 1000;
export const MAP_FLY_ZOOM = 9;
// Map > Zoom
export const MAP_ZOOM_TYPES: MapZoomType[] = ["fit", "me", "in", "out"];
// Map > Throttle
export const MAP_THROTTLE_DURATION = 16;